/* src/app/component/reject-modal/reject-modal.component.scss */
.btn-1 {
  display: inline-block;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  border-radius: 8px;
  padding: 10px 18px;
  cursor: pointer;
  transition:
    background-color 0.3s,
    color 0.3s,
    border-color 0.3s;
}
.rejectcontent {
  color: #102810;
  font-size: 16px;
}
.rejectreason {
  margin-top: 24px;
}
.rejectreason span {
  color: #344054;
  font-weight: 500;
}
.btn-warning-1 {
  background-color: white;
  color: #000;
  border: 1px solid #D0D5DD;
}
.btn-warning-2 {
  background-color: #fff;
  color: #D92D20;
  border: 1px solid #D92D20;
}
.btn-1:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
.btn-warning-2:focus {
  outline: none;
  box-shadow: none;
}
textarea {
  border-radius: 10px;
  padding: 10px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  color: #000;
  width: 100%;
  border-color: #D0D5DD;
}
textarea:focus {
  border-color: orange !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF;
  outline: none;
}
textarea::placeholder {
  color: #667085;
}
::ng-deep .p-dialog-draggable .p-dialog-header {
  padding: 32px 24px;
}
.invalid-textarea {
  border: 1px solid red;
}
.error-text {
  color: #e24c4c;
  font-size: 13px;
  margin-top: 4px;
}
button:disabled {
  background-color: #f1f3f5;
  color: #adb5bd;
  border: none;
  border-radius: 8px;
  cursor: not-allowed !important;
  font-weight: 600;
  opacity: 1;
}
/*# sourceMappingURL=reject-modal.component-UY7ZDLXO.css.map */
